import React, { Fragment } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { Menu, MenuItem, MenuButton, useMenuProps } from '../../../../components/DropdownSet';
import Tooltip from '../../../../components/Tooltip';

export const DashboardTabNavigation = ({ sections, onScrollToSection }) => (
  <nav className="dashboard-tab-navigation">
    {sections.map((section, index) => (
      <Fragment key={section.id}>
        {index > 0 && <span className="dashboard-tab-navigation__separator">&middot;</span>}
        <Tooltip content={section.tooltip} placement="bottomLeft" colorVariant="light">
          <span
            className="dashboard-tab-navigation__link"
            onClick={() => onScrollToSection(section.id)}
          >
            {section.label}
          </span>
        </Tooltip>
      </Fragment>
    ))}
  </nav>
);

export const DashboardTabNavigationDropdown = ({ active, sections, onScrollToSection }) => {
  const menuProps = useMenuProps({ className: 'dashboard-sticky-header__menu' });

  if (!active) return null;

  return (
    <Menu
      menuButton={
        <MenuButton frameless className="dashboard-sticky-header__nav-btn">
          {active.label}
        </MenuButton>
      }
      {...menuProps}
    >
      {sections.map((section) => (
        <MenuItem
          key={section.id}
          className={cx({
            active: active.id === section.id,
          })}
          onClick={() => onScrollToSection(section.id)}
        >
          {section.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

const TabNavigationPropTypes = {
  sections: T.arrayOf(
    T.shape({
      id: T.string.isRequired,
      label: T.string.isRequired,
      tooltip: T.string,
    })
  ).isRequired,
  onScrollToSection: T.func.isRequired,
};

DashboardTabNavigation.propTypes = TabNavigationPropTypes;

DashboardTabNavigationDropdown.propTypes = {
  ...TabNavigationPropTypes,
  active: T.shape({
    id: T.string.isRequired,
    label: T.string.isRequired,
  }),
};
